import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Typography,
  Box,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { updateEndorsementFormData } from 'src/features/rfqDataSlice';

const fields = [
  { key: 'insuredName', label: 'Insured Name' },
  { key: 'address', label: 'Full Address' },
  { key: 'branchName', label: 'Branch Name' },
  { key: 'city', label: 'City' },
  { key: 'pincode', label: 'Pincode' },
  { key: 'gstNo', label: 'GST No.' },
];

const CustomerDetails = ({ policyDetails }) => {
  const dispatch = useDispatch();
  const [sectionEditable, setSectionEditable] = useState(false);
  const [fieldEditable, setFieldEditable] = useState({
    insuredName: false,
    address: false,
    branchName: false,
    city: false,
    pincode: false,
    gstNo: false,
    insuredNameValue: '',
    addressValue: '',
    branchNameValue: '',
    cityValue: '',
    pincodeValue: '',
    gstNoValue: '',
  });

  const handleSectionChange = (event) => {
    const checked = event.target.checked;
    setSectionEditable(checked);

    setFieldEditable((prev) =>
      Object.fromEntries(
        Object.entries(prev).map(([k, _]) => [k, checked])
      ) as typeof prev
    );
  };

const handleFieldChange = (key) => (event) => {
  const checked = event.target.checked;
  const valueKey = `${key}Value`;
  const valueFromPolicy = policyDetails.customerData[key] || '';

  setFieldEditable((prev) => ({
    ...prev,
    [key]: checked,
    [valueKey]: checked ? valueFromPolicy : '', 
  }));
};


  useEffect(() => {
    dispatch(updateEndorsementFormData({
      customerData: fieldEditable

    }))

  }, [fieldEditable])

  return (
    <>
      {policyDetails.customerData && <>
        <Box sx={{ mb: 1, display: 'flex', gap: 1 }}>

          <Typography variant="h5" className='heading' style={{
            background: 'rgb(9 84 174)', color: '#fff',
            paddingTop: '6px', paddingBottom: '6px', fontWeight: 'bold', width: '100%', paddingLeft: '16px'
          }}>Customer Details</Typography>
        </Box>

        <Grid container spacing={2} style={{ paddingLeft: '16px' }}>
          {fields.map(({ key, label }) => (
            <Grid item xs={12} md={4} key={key}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={fieldEditable[key]}
                    onChange={handleFieldChange(key)}
                  />
                }
                label={`${label} : ${policyDetails?.customerData[key]?policyDetails?.customerData[key]:'N/A'} `}
              />
            </Grid>
          ))}
        </Grid>
      </>}

    </>



  );
};

export default CustomerDetails;
